module.exports = __webpack_public_path__ + "money.svg?b9ba9d5191425d16a491fbc7589fad12";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/money.svg
// module id = 87
// module chunks = 0